exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".backArrow--3VAlHNJw{border:none;background:none;-webkit-appearance:none;appearance:none;height:3rem;width:auto;padding:0;margin:0}.backArrow--3VAlHNJw:active{border:none;box-shadow:none;opacity:.9}.backArrow--3VAlHNJw svg{height:3rem;width:3rem;display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center}.backArrowPositioning--2YWwH34r{position:absolute;left:0;top:0;z-index:999}.backArrowPositioning--2YWwH34r svg{fill:#fff}", ""]);

// exports
exports.locals = {
	"backArrow": "backArrow--3VAlHNJw",
	"backArrowPositioning": "backArrowPositioning--2YWwH34r"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/sign_up/shared/backArrow/styles.scss
// module id = 1039
// module chunks = 0